import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { dealApi, dealQueryKeys } from '@crm/entities/deal';
import { toastManager } from '@crm/entities/toast';
import { getApiErrorMessage } from '@crm/shared/api';

import type { TDeal, TSwitchDealTaskStatusParams } from '@crm/entities/deal';

export const useSwitchDealTaskStatusMutation = ({ dealId }: { dealId: TDeal['id'] }) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [...dealQueryKeys.detail(dealId), 'tasks', 'switch-status'],
        mutationFn: ({ payload, taskUid }: Omit<TSwitchDealTaskStatusParams, 'dealId'>) =>
            dealApi.switchDealTaskStatus({ dealId, payload, taskUid }),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: dealQueryKeys.detail(dealId) });
        },
        onError: (error) => {
            toastManager.onError({
                title: getApiErrorMessage(
                    error,
                    t('crm.dealDetailsContent.tasksBlock.errors.changeStatus')
                ),
            });
        },
    });
};
